// Internationalisation : français complet, anglais pour les pages publiques.
const fr = {
  'nav.test': 'Test',
  'nav.history': 'Historique',
  'nav.observatory': 'Observatoire',
  'nav.method': 'Méthodologie',
  'nav.partners': 'Partenaires',
  'nav.skip': 'Aller au contenu',
  'theme.toggle': 'Changer de thème',
  'test.title': 'Mesurez votre connexion',
  'test.subtitle': 'Débit, latence et réactivité sous charge. Indépendant, open source, sans traceur.',
  'test.start': 'Lancer le test',
  'test.restart': 'Relancer le test',
  'test.cancel': 'Annuler',
  'test.server': 'Serveur',
  'test.server.auto': 'Choix automatique (latence la plus faible)',
  'test.conntype': 'Type de connexion',
  'test.contribute': 'Contribuer aux statistiques publiques (anonymisées)',
  'test.location': 'Utiliser ma position (arrondie à la commune)',
  'test.multi': 'Mode multi-serveurs',
  'phase.session': 'Préparation…',
  'phase.latence': 'Latence',
  'phase.descendant': 'Débit descendant',
  'phase.montant': 'Débit montant',
  'phase.fin': 'Terminé',
  'res.download': 'Descendant',
  'res.upload': 'Montant',
  'res.latency': 'Latence au repos',
  'res.jitter': 'Gigue',
  'res.loaded': 'Latence sous charge',
  'res.grade': 'Réactivité',
  'res.loss': 'Perte de paquets',
  'res.share': 'Partager',
  'res.copy': 'Copier le lien',
  'res.copied': 'Lien copié',
  'res.image': 'Image',
  'res.server': 'Serveur',
  'res.uploadNote': 'mesuré par le serveur',
  'conn.fibre': 'Fibre (FTTH)',
  'conn.cable': 'Câble',
  'conn.dsl': 'ADSL / VDSL',
  'conn.4g': '4G',
  'conn.5g': '5G',
  'conn.satellite': 'Satellite',
  'conn.wifi-public': 'Wi-Fi public',
  'conn.autre': 'Autre / je ne sais pas',
  'unit.mbps': 'Mbit/s',
  'unit.ms': 'ms',
} as const;

type Key = keyof typeof fr;

const en: Partial<Record<Key, string>> = {
  'nav.test': 'Test',
  'nav.history': 'History',
  'nav.observatory': 'Observatory',
  'nav.method': 'Methodology',
  'nav.partners': 'Partners',
  'nav.skip': 'Skip to content',
  'theme.toggle': 'Toggle theme',
  'test.title': 'Measure your connection',
  'test.subtitle': 'Speed, latency and responsiveness under load. Independent, open source, no trackers.',
  'test.start': 'Start test',
  'test.restart': 'Run again',
  'test.cancel': 'Cancel',
  'test.server': 'Server',
  'test.server.auto': 'Automatic (lowest latency)',
  'test.conntype': 'Connection type',
  'test.contribute': 'Contribute to public (anonymised) statistics',
  'test.location': 'Use my location (rounded to the municipality)',
  'test.multi': 'Multi-server mode',
  'phase.session': 'Preparing…',
  'phase.latence': 'Latency',
  'phase.descendant': 'Download',
  'phase.montant': 'Upload',
  'phase.fin': 'Done',
  'res.download': 'Download',
  'res.upload': 'Upload',
  'res.latency': 'Idle latency',
  'res.jitter': 'Jitter',
  'res.loaded': 'Latency under load',
  'res.grade': 'Responsiveness',
  'res.loss': 'Packet loss',
  'res.share': 'Share',
  'res.copy': 'Copy link',
  'res.copied': 'Link copied',
  'res.image': 'Image',
  'res.server': 'Server',
  'res.uploadNote': 'measured by the server',
};

export const lang: 'fr' | 'en' = navigator.language?.toLowerCase().startsWith('fr')
  ? 'fr'
  : (() => {
      try {
        return (localStorage.getItem('lang') as 'fr' | 'en') ?? 'fr';
      } catch {
        return 'fr';
      }
    })();

export function t(k: Key): string {
  return (lang === 'en' ? en[k] : undefined) ?? fr[k];
}
